import React from 'react';
import './Footer.css';

const Footer = () => {
    return (
        <footer>
            Developed By <a href="https://rirefat.netlify.app/" target="_blank">Rafiul Islam Refat</a> || 2023
        </footer>
    );
};

export default Footer;